// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"9aa93cbc","123":"fa36b74b","525":"6b6ff221","636":"f073fc9a"}[chunkId] + ".css";
};